import type { EntityKey, ToolKey } from './tools';

const files = import.meta.glob('../assets/icons/*.{svg,png}', { eager: true, query: '?url', import: 'default' }) as Record<string, string>;

/** Alle Dateien des Ordners `assets/icons` nach Dateiname ohne Endung („time-range-icon“ → URL). */
const byStem = new Map<string, string>(Object.entries(files).map(([path, url]) => [path.replace(/^.*\//, '').replace(/\.(svg|png)$/i, ''), url]));

/** Werkzeuge der Handlung, Bereiche der Bibliothek und `period` (Zeiträume beim Ziehen; ein eigenes Werkzeug gibt es nicht mehr) */
type IconKey = ToolKey | EntityKey | 'period';

/** Zusätzliche Dateinamen, unter denen ein Icon gefunden wird (neben dem Schlüssel). */
const ALIASES: Partial<Record<IconKey, string[]>> = { period: ['time-range'], timeline: ['time-line'], object: ['thing', 'item'], concept: ['idea'] };

/**
 * Icon eines Werkzeugs bzw. Bereichs aus `assets/icons`. Eigene Dateien haben Vorrang vor dem Standardicon: erst `<name>-icon`
 * (z. B. `time-range-icon.png`), dann `<name>` (z. B. `period.svg`), jeweils für den Schlüssel und die Aliase.
 */
export function iconFor(key: IconKey): string | null {
  const names = [key, ...(ALIASES[key] ?? [])];
  for (const stem of [...names.map((n) => `${n}-icon`), ...names]) {
    const url = byStem.get(stem);
    if (url) return url;
  }
  return null;
}

/** Icon nach Dateiname ohne Endung (z. B. „world“ für den Bereich Welt der Bibliothek), sonst null. */
export const iconNamed = (stem: string): string | null => byStem.get(`${stem}-icon`) ?? byStem.get(stem) ?? null;
